<template>
  <base-link
    :aria-label="$t.locationSelector"
    class="group flex items-center gap-2"
    to="/location-selector"
    @click="$gtm.push('topNav.onClickCountrySelector')"
  >
    <vf-location-flag />
    <span class="underscore-base group-hover:underscore-on">
      {{ languageCode }}
      <slot />
    </span>
  </base-link>
</template>

<script lang="ts" setup>
const languageCode = useLanguageCode()
</script>
